/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { CalcLib, CalcLibInterface } from "../CalcLib";

const _abi = [
  {
    inputs: [],
    name: "MAX_CHANCE",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class CalcLib__factory {
  static readonly abi = _abi;
  static createInterface(): CalcLibInterface {
    return new Interface(_abi) as CalcLibInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): CalcLib {
    return new Contract(address, _abi, runner) as unknown as CalcLib;
  }
}
